<template>
  <div class="tabs">

    <!-- <div class="tabs-header">
      <mac-left-space />
      <div class="tabs-ctn">
        <hitab v-model="curTabKey" :tabs="tabs" theme="custom" ref="tabs" :insert-to-after="true" :gap="2"
               :onClose="closeTabHandler" :onDblClick="dupTab" @contextmenu.prevent="tabCtxMenu(arguments[0], arguments[1], arguments[2])">
          <div slot="after" style="-webkit-app-region: no-drag;" class="tabs-after-ctn">
            <i class="el-icon-plus tab-btn" @click="addTab({})" />
            <tab-shell-selector @command="shellCommandHandler"><i class="el-icon-arrow-down tab-btn"></i></tab-shell-selector>
          </div>
        </hitab>
      </div>

      <div v-if="isElectron" style="-webkit-app-region: drag; width: 45px" @dblclick="utils.electron.toggleMaxWinOnMac" />
      <div>
        <el-popover v-model="menuVisible" placement="bottom-end" width="222" trigger="click" :visible-arrow="false" :popper-options="menuProperOptions" class="menu-popover">
          <tabsTopMenu @addNewSess="$emit('addNewSess')" />
          <div slot="reference" class="el-icon-menu tabs-menu tab-btn" />
        </el-popover>
      </div>

      <winCtrl v-if="isElectron" v-show="os === 'win32' || os === 'linux'" />
    </div> -->

    <app-hdr class="app-hdr">
      <div class="tabs-ctn">
        <hitab v-model="curTabKey" :tabs="tabs" theme="custom" ref="tabs" :insert-to-after="true" :gap="2"
               :onClose="closeTabHandler" :onDblClick="dupTab" @contextmenu.prevent="tabCtxMenu(arguments[0], arguments[1], arguments[2])">
          <div slot="after" style="-webkit-app-region: no-drag;" class="tabs-after-ctn">
            <i class="el-icon-plus tab-btn" @click="addTab()" />
            <tab-shell-selector @command="shellCommandHandler"><i class="el-icon-arrow-down tab-btn"></i></tab-shell-selector>
          </div>
        </hitab>
      </div>

      <template v-slot:ctrl >
        <el-tooltip v-if="updateVerBtnVisible" content="新版本已就绪，点击退出所有窗口并更新" placement="top-start">
          <div class="el-icon-upload tab-btn tab-btn-upgrade" @click="utils.electron.exitService('exitServiceForUpgrade')" />
        </el-tooltip>
        
        <dropdown>
          <div class="el-icon-menu tab-btn" slot="btn" />
          <main-menu @addNewSess="$emit('addNewSess')" />
        </dropdown>
      </template>
    </app-hdr>

    <terminal class="tab-terms-ctn" v-for="t in tabs" :key="t.key"
              :tabID="t.key" :sessAndPath="t.sessAndPath" :shellCmd="t.shellCmd"
              v-show="curTabKey === t.key"
              :tab="t"
              @updateStatus="updateSessStatus"
              @terminalUpdateShellCmd="terminalUpdateShellCmd"
    />

    <el-dialog :visible.sync="closeSureVisible" width="333px"  @open="focusCloseSureCloseBtn" @closed="focusCurTerm">
      <span>会话仍处于连接状态, 是否断开会话并关闭</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideCloseSureDialog" size="mini">取 消</el-button>
        <el-button id="closeSureVisibleCloseBtn" @click="closeClosingTab" size="mini">关 闭</el-button>
      </span>
    </el-dialog>

    <context-menu id="tab-context-menu" ref="tabCtxMenu" class="ctx-menu">
      <ctx-menu-item @click="closeTab(ctxMenuTab.key)" :hot-key="utils.hotKey.getTextByName('closeCurSession')">关闭</ctx-menu-item>
      <ctx-menu-item @click="closeTabRight">关闭右侧</ctx-menu-item>
      <ctx-menu-item @click="closeTabOther">关闭其它</ctx-menu-item>
      <ctx-menu-item @click="closeTabAll">关闭全部</ctx-menu-item>
      <ctx-menu-item @click="closeTabDisconnected">关闭失联会话</ctx-menu-item>
      <ctx-menu-item :disabled="true" :isDivider="true" />
      <ctx-menu-item @click="dupTab(ctxMenuTab)" :hot-key="utils.hotKey.getTextByName('dupCurSession')">复制</ctx-menu-item>
      <ctx-menu-item v-show="ctxMenuTab && curTabKey === ctxMenuTab.key" @click="fullscreenTab(ctxMenuTab)" :hot-key="utils.hotKey.getTextByName('toggleSessFullscreen')">全屏显示</ctx-menu-item>
    </context-menu>
  </div>
</template>

<script>
import terminal from '../session/terminal/terminal.vue'
import contextMenu from 'vue-context-menu'
import ctxMenuItem from '../common/ctxMenuItem.vue'
import TabShellSelector from "./tabShellSelector";
import AppHdr from '../common/appHdr.vue'
import MainMenu from './mainMenu.vue'
import Dropdown from '../common/dropdown.vue'

export default {
  name: "tab",
  components: {
    TabShellSelector,
    terminal,
    contextMenu,
    ctxMenuItem,
    AppHdr,
    MainMenu,
    Dropdown,
  },
  data() {
    return {
      curTabKey: undefined, // 当前选中的标签，直接修改这个值即可修改选中的标签
      tabs: [],
      closeSureVisible: false,
      closingTab: undefined,
      closingMulti: false,
      menuProperOptions: {
        gpuAcceleration: true,
      },
      menuVisible: false,

      os: this.env.os,
      isElectron: this.env.isElectron,

      ctxMenuEvent: undefined,
      ctxMenuTab: undefined,
      ctxMenuTabIndex: undefined,

      updateVerBtnVisible: false,
    }
  },
  watch: {
    curTabKey: function(newCurTab, oldCurTab) {
      // console.log(`curTab change from ${oldCurTab} to ${newCurTab}`)
      let self = this

      self.env.tab.curTabKey = newCurTab

      this.env.pub('blurTerm-' + oldCurTab)
      // this.env.pub('focusTerm-' + newCurTab)
      this.focusCurTerm()

      // curtab 发生变化时, sessStatus 如果是 unread 则需要变为 open
      this.updateCurTabStatus()

      // curtab 发生变化时, window 尺寸没有变化, 不会自动触发 resize 事件, 这里需要触发一下
      this.env.pub('resize-' + newCurTab)

      let curTab = this.getTabByKey(newCurTab)
      this.env.tabCurrentChange("termTabs", curTab, this.getTabByKey(oldCurTab))
      document.title = curTab.label
    },
    closeSureVisible: function(newStatus) {
      // 每次关闭关闭窗口确认框的时候都将 closingTab 设置为 undefined
      if (newStatus === false) {
        this.closingTab = undefined
      }
    },
  },
  mounted() {
    let self = this

    self.env.sub("tabNext", self.tabNextHandler)
    self.env.sub("tabPrev", self.tabPrevHandler)
    self.env.sub("dupCur", () => { self.dupTab(self.getTabByKey(self.curTabKey)) })
    self.env.tab.fullscreenCurAddCallback(() => { self.fullscreenTab(self.getTabByKey(self.curTabKey)) })
    self.env.tabDestroyAddCallback((tabKey) => { self.closeTab(tabKey)})
    self.env.tabDestroyCurrentAddCallback(() => { self.closeTabHandler(self.getTabByKey(self.curTabKey))} )
    self.env.tabDupAddCallback(() => { self.addTab() })
    self.env.tabCurrentReconnectAddCallback(() => { self.env.pub(`sessionReconnect-${self.curTabKey}`)} )
    self.env.hideTabsTopMenuAddCallback(() => {self.menuVisible = false})
    self.env.termFocusCurrentAddCallback(() => {self.env.pub('focusTerm-' + self.curTabKey)})
    self.env.tabNewTabAddCallback((sessAndPath) => {self.addTab(sessAndPath)})
    self.env.term.exportCurLogAddCallback(() => {self.env.pub('export-log-' + self.curTabKey)})
    self.env.term.printCurLogAddCallback(() => {self.env.pub('print-log-' + self.curTabKey)})
    self.env.ui.showCurTermSearchAddCallback(() => {self.env.pub('show-term-search-' + self.curTabKey)})
    self.env.ui.showCurTermVimModeAddCallback(() => {self.env.pub('show-term-vim-mode-' + self.curTabKey)})
    self.env.ui.showUpdateDownloadedAddCallback(() => { self.updateVerBtnVisible = true })

    // 如果打开界面时没有显示会话列表, 则打开一个新的本地会话
    if (!this.env.ui.getShowSessionsOnNewWindow()) this.addTab()
  },
  methods: {
    newTabKey: function() {
      return 'tab-' + Date.now() + Math.trunc((Math.random * 1000))
    },
    // 添加会话, sessAndPath 不为空对象，则根据指定的 sessAndPath 打开一个会话
    // 如果 sessAndPath 为空，则根据 shellName 打开一个对应的本地 shell 会话（e.g: zsh/bash）
    // 如果 sessAndPath 和 shellName 都为空，则打开一个默认的本地 shell 会话
    addTab: function(sessAndPath, shellCmd) {
      let key = this.newTabKey()

      // 如果设备上从未设置过 default session， 那么 this.utils.conf.loadLocalSessDefault() 在启动时会返回空值
      // 这种场景由后端处理，同样选择 shell detector 返回的 shell list 的第一个选项作为默认 shell
      // 后端打开之后，会通知 terminal terminalUpdateShellCmd, terminal 会通知 tags terminalUpdateShellCmd
      // tabs 处理 terminalUpdateShellCmd 时会同时更新 label
      console.log("addTab: sessAndPath", sessAndPath)
      console.log("addTab: shellCmd", shellCmd)
      if (!sessAndPath && !shellCmd) {
        
        shellCmd = this.utils.conf.loadLocalSessDefault()
        console.log("addTab: no sessAndPath or shellCmd, add ", shellCmd)
      }
      
      let label = shellCmd
      console.log("label:", label)
      if (sessAndPath && sessAndPath.sess && sessAndPath.sess.Name) {
        label = sessAndPath.sess.Name
      }
      console.log("label:", label)

      let newTabs = [
        {
          label: label,
          key: key,
          sessAndPath: sessAndPath,
          shellCmd: shellCmd,
          sessStatus: "connecting",
          favicon: this.badge,
        }
      ]
      this.$refs.tabs ? this.$refs.tabs.addTab(...newTabs) : console.log("addTab: invalid this.$refs.tabs: ", this.$refs.tabs)
      this.curTabKey = key
    },
    focusCloseSureCloseBtn() {
      this.utils.domFocusById('closeSureVisibleCloseBtn')
    },
    focusCurTerm() {
      // this.env.pub('focusTerm-' + this.curTabKey)
      this.focusTerm(this.curTabKey)
    },
    focusTerm(key) {
      this.env.pub('focusTerm-' + key)
    },
    closeTabDisconnected() {
      let keys = []
      this.tabs.forEach(t => { this.isTabDisconnected(t) ? keys.push(t.key) : null })

      let self = this
      this.$confirm(`即将已失联会话(共 ${keys.length} 个会话), 是否继续?`, '关闭失联会话', {
        confirmButtonText: '关闭',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.closingMulti = true
        keys.forEach( k => { self.$refs.tabs.removeTab(k) })
        self.closingMulti = false

        if (!self.isTabExist(self.curTabKey)) {
          self.tabs.length > 0 ? self.curTabKey = self.tabs[0].key : null
        }
      }).catch(() => {
        console.debug("cancel close all sessions")
      })
    },
    closeTabOther() {
      let self = this
      if (this.tabs.length < 2) return

      this.$confirm(`即将其它会话(共 ${this.tabs.length - 1} 个会话), 是否继续?`, '关闭其它会话', {
        confirmButtonText: '关闭',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.closingMulti = true
        let keys = []
        self.tabs.forEach( t => { t.key !== this.ctxMenuTab.key ?  keys.push(t.key) : null })
        keys.forEach( k => { self.$refs.tabs.removeTab(k) })
        self.closingMulti = false
      }).catch(() => {
        console.debug("cancel close all sessions")
      })
    },
    closeTabRight() {
      let nidx = this.ctxMenuTabIndex + 1
      if (nidx === this.tabs.length) return

      let self = this
      this.$confirm(`即将关闭右边标签(共 ${this.tabs.length - nidx} 个会话), 是否继续?`, '关闭多个会话', {
        confirmButtonText: '确认关闭',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.closingMulti = true
        while (self.tabs.length > nidx) { self.$refs.tabs.removeTab(self.tabs[self.tabs.length - 1].key) }
        self.closingMulti = false
      }).catch(() => {
        console.debug("cancel close right sessions")
      })
    },
    // 关闭所有标签
    closeTabAll() {
      let self = this
      this.$confirm(`即将关闭所有会话(共 ${this.tabs.length} 个会话), 是否继续?`, '关闭所有会话', {
        confirmButtonText: '全部关闭',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.closingMulti = true
        while (self.tabs.length > 0) { self.$refs.tabs.removeTab(self.tabs[0].key) }
        self.closingMulti = false
      }).catch(() => {
        console.debug("cancel close all sessions")
      })
    },
    // 关闭标签
    closeTab(tabKey) {
      // console.log(`closeTab: tabKey: `, tabKey)
      let tabs = this.$refs.tabs
      tabs ? tabs.removeTab(tabKey) : null
      this.hideCloseSureDialog()
    },
    closeClosingTab() {
      // console.log("closeClosingTab: this.closingTab:", this.closingTab)
      this.closeTab(this.closingTab.key)
    },
    // 点击关闭标签按钮时触发, 返回 true 关闭标签，返回 false 不关闭标签
    closeTabHandler(tab) {
      if (this.closingMulti) {
        return true
      }

      // console.log(`closeTabHandler: tab:`, tab)
      // 要关闭的 tab 对应的 session 会话面已经断开， 直接关闭
      if (this.isTabDisconnected(tab)) {
        // console.log("closeTabHandler: close directly")
        return true
      }

      // 未经确认关闭时设置 closingTab，只是打开确认界面(打开确认界面会自动设置 this.closingTab)，不关闭会话
      // console.log("closeTabHandler: this.closingTab: ", this.closingTab)
      if (!this.closingTab) {
        // console.log("closeTabHandler: only show sure dialog")
        this.showCloseSureDialog(tab)
        return false
      }

      // console.log("closeTabHandler: close with sure")
      // 已经经过确认关闭界面设置 this.closingTab，返回 true 关闭 tab
      return true
    },
    isTabDisconnected(tab) {
      if (!tab) return true
      if (!tab.sessStatus || tab.sessStatus === "close" || tab.sessStatus === "error") {
        return true
      }
    },
    isTabExist(key) {
      let found = false
      this.tabs.forEach(t => { t.key === key ? found = true : null })
      return found
    },
    showCloseSureDialog(closingTab) {
      this.closingTab = closingTab
      this.closeSureVisible = true
    },
    hideCloseSureDialog() {
      // 在 closeSureVisible 的 watcher 中, 当 visible 变为 false 的时候设置 closingTab 为 undefined
      // this.closingTab = undefined
      this.closeSureVisible = false
    },
    tabNextHandler() {
      let nextIndex = this.nextTabIndex()
      nextIndex < 0 ? this.$message.error(`Get next tab failed`) : this.curTabKey = this.tabs[nextIndex].key
    },
    tabPrevHandler() {
      let self = this
      let index = self.curTabIndex()

      if (index < 0) {
        self.$message.error(`internal error: could not found current tab key: ${self.curTabKey} in ${self.tabs}`)
        return
      }

      let prevIndex = --index
      if (prevIndex < 0) {
        prevIndex = self.tabs.length - 1
      }
      // console.log("termTabs: tabPrevHandler: fixed prevIndex", prevIndex)
      self.curTabKey = self.tabs[prevIndex].key
    },
    // updateCurTabLabel(label) {
    //   this.tabs[this.curTabIndex()].label = label
    // },
    // updateTitleHandler(tab, title) {
    //   console.log("updateTitleHandler: tab:", tab)
    //   console.log("updateTitleHandler: title:", title)
    //   if (tab.key === this.curTabKey) {
    //     document.title = title
    //   }
    //
    //   if (this.isDefaultLabel(tab.label)) {
    //     tab.label = this.utils.xtermjs.splitTitle(title).host
    //   }
    // },
    // isDefaultLabel(label) {
    //   if (!label || label === "") {
    //     return false
    //   }
    //
    //   let re = RegExp("^\\d+ Local Shell$")
    //   if (label.match(re) !== null) {
    //     return true
    //   }
    //   return false
    // },
    nextTabIndex() {
      let index = this.curTabIndex()

      if (index < 0) {
        return -1
      }

      let nextIndex = ++index
      if (nextIndex >= this.tabs.length) {
        nextIndex = 0
      }
      return nextIndex
    },
    curTabIndex() {
      return this.tabIndex(this.curTabKey)
    },
    getTabByKey(tabKey) {
      let self = this
      for (let t of self.tabs) {
        if (t.key === tabKey) {
          return t
        }
      }
      return null
    },
    tabIndex(tabKey) {
      let self = this
      let index = -1
      for (let i = 0; i < self.tabs.length; i++) {
        if (self.tabs[i].key === tabKey) {
          index = i
          break
        }
      }
      return index
    },
    updateSessStatus(tabKey, status) {
      // console.log(`updateSessStatus: tabKey: ${tabKey}, status: ${status}`)
      this.getTabByKey(tabKey).sessStatus = status
    },
    updateCurTabStatus() {
      let tab = this.getTabByKey(this.curTabKey)
      tab && tab.sessStatus === "unread" ? tab.sessStatus = "open" : null
    },
    // 生成 badge 的函数
    badge(h, { tab }) {
      // console.log(`favicon: tab: ${tab}, index: ${index}`)
      let color = ""
      switch (tab.sessStatus) {
        case "connecting":
          color = "yellow"
          break;
        case "open":
          color = "green"
          break;
        case "unread":
          color = "blue"
          break;
        case "close":
        case "error":
          color = "red"
          break;
        default:
          return
      }
      return h(`tab-badge-${color}`)
    },
    dupTab(tab) {
      if (tab === null || tab === undefined) {
        console.log("dupTab skip dup invalid tab:", tab)
        return
      }

      if (!tab.shellCmd && !tab.sessAndPath) {
        return
      }

      if (tab.shellCmd) {
        this.addTab({}, tab.shellCmd)
        return
      }

      let sp = JSON.parse(JSON.stringify(tab.sessAndPath))
      this.addTab(sp)
    },
    tabCtxMenu(e, tab, index) {
      this.ctxMenuEvent = e
      this.ctxMenuTab = tab
      this.ctxMenuTabIndex = index
      this.$refs.tabCtxMenu.open()
    },
    fullscreenTab(tab) {
      console.log("fullscreenTab: tab: ", tab)
      if (!tab) return
      let self = this
      let el = this.$el.querySelector(`#${ tab ? tab.key : "fake"}`)
      this.$fullscreen.toggle(el, {
        teleport: false,
        callback: (isFullscreen) => {
          this.fullscreen = isFullscreen
          self.focusTerm(tab ? tab.key : console.log("skip focus fullscreen tab cause by invalid tab:", tab))
          self.env.pub('resize-' + self.curTabKey)
          // setTimeout(() => {self.env.pub('resize-' + self.curTabKey)}, 2000)
          // console.log(" this.$fullscreen", this.$fullscreen)
          // el.addEventListener('change', (e) => {
          //   console.log("fullscreen change:", e)
          // })
        },
      })
    },
    shellCommandHandler(command) {
      console.log("shellCommandHandler:", command)
      this.addTab({}, command)
    },
    terminalUpdateShellCmd(tabID, shellCmd) {
      let tab = this.getTabByKey(tabID)
      tab.shellCmd = shellCmd
      tab.label = shellCmd
    }
  },
}
</script>


<style scoped>
.tabs {
  display: flex;
  flex-direction: column;

  font-size: 14px;
  background: #1e1e1e;
  /* background: #2d2d2d; */
}

.app-hdr {
  background-color: #3c3c3c;
}

.tabs-ctn {
  width: 100%;
}

.tabs-menu {
  flex-grow: 0;
}

.tabs-after-ctn {
  width: 60px;
  min-width: 60px;
} 

.tab-terms-ctn {
  flex-grow: 1;
  height: 100%;

  padding: 0 0 0 8px;
}

.tab-btn {
  color: #c6c6c6;
  padding: 8px;
}
.tab-btn:hover {
  color: white;
  background: #333333;
}
.tab-btn:active {
  color: white;
  background: #111;
}
.tab-btn-upgrade {
  color: #26F7A7;
}

.ctx-menu {
  background-color: #1e1e1e;
}
</style>

<style lang="less">
.hitab.theme-custom {
  padding-top: 0;
  color: #919191;
  background-color: transparent;
  overflow: hidden;
  .tabs-footer,
  .tabs-divider,
  .tabs-background-before,
  .tabs-background-after {
    display: none;
  }
  .tabs-content {
    overflow: unset;
    height: 30px;
    .tabs-item {
      .tabs-background {
        padding: 0;
        .tabs-background-content {
          background-color: transparent;
          border-radius: 0;
          border-left: #343434 solid 1px;
        }
      }
    }
  }
  .active {
    color: #fff;
    background-color: #1e1e1e;
    .tabs-background {
      &::before,
      &::after {
        top: 100%;
        left: 0;
        content: '';
        width: 100%;
        height: 0;
        z-index: 1;
        position: absolute;
      }
      //&::before {
      //  top: 0;
      //  height: 2px;
      //  background-color: #409eff;
      //}
    }
  }
}
</style>
